import React from 'react';
import { Button } from 'react-bootstrap';
import { FaBars } from 'react-icons/fa';

const Header = ({ onToggleSidebar }) => {
  return (
    <header className="admin-header">
      <div className="d-flex align-items-center">
        <Button 
          variant="outline-secondary" 
          className="me-3 d-md-none"
          onClick={onToggleSidebar}
        >
          <FaBars />
        </Button>
        <h1 className="h4 mb-0">Limousine Booking Admin</h1>
      </div>
      <div className="admin-header-right">
        <span className="me-2">Welcome, Admin</span>
        <div className="admin-avatar">A</div>
      </div>
    </header>
  );
};

export default Header;